import * as React from "react";

import Game from "./components/Game";
import "./App.css";

const App = () => {
  return <Game />;
};

export default App;
